export enum ExamScoringType {
    FirstAttempt = 3,
    LastAttempt = 2,
    Average = 1,
    Highest = 0,
    Lowest = 4
}